module.exports = __webpack_public_path__ + "img/monmi-rm.9931c331.png";